__turbopack_context__.v({
  "disclaimer": "m4emcG_disclaimer",
  "footerBox": "m4emcG_footerBox",
  "imagesContainer": "m4emcG_imagesContainer",
  "noResultsContent": "m4emcG_noResultsContent",
  "noResultsProducts": "m4emcG_noResultsProducts",
  "searchCategory": "m4emcG_searchCategory",
  "searchContent": "m4emcG_searchContent",
  "searchResultsContainer": "m4emcG_searchResultsContainer",
  "searchSubtitle": "m4emcG_searchSubtitle",
  "skinText": "m4emcG_skinText",
});
